module.exports = __webpack_public_path__ + "f08443aba01ba780ccb15cab40403e81.ttf";